export const CANCELLATION_REASONS = [
  { value: 'too_expensive', label: 'Too Expensive' },
  { value: 'not_using_it_enough', label: 'Not Using it Enough' },
  { value: 'missing_features', label: 'Missing Features' },
  { value: 'technical_issues', label: 'Technical Issues' },
  { value: 'switching_providers', label: 'Switching Providers' },
  { value: 'business_is_closing', label: 'Business is Closing' },
  { value: 'others', label: 'Others' }
] as const;

export type CancellationReasonValue = (typeof CANCELLATION_REASONS)[number]['value'];

export function getCancellationReasonLabel(reason?: string | null): string | undefined {
  if (!reason) return undefined;
  return CANCELLATION_REASONS.find((item) => item.value === reason)?.label ?? reason;
}
